export default "__VITE_ASSET__Bv8jY0O6__"